/**
 * Base class for all process results
 */
export class ProcessResult {
  ResultUrl: string;
  RequestedDate: string;
  ResultType: string;
  ProcessType: string;
  GeneratedAt: string;
  AssetId: string;

  constructor(data: any) {
    this.ResultUrl = data.ResultUrl;
    this.RequestedDate = data.RequestedDate;
    this.ResultType = data.ResultType;
    this.ProcessType = data.ProcessType;
    this.GeneratedAt = data.GeneratedAt;
    this.AssetId = data.AssetId;
  }
}
